export default __webpack_public_path__ + "static/media/search.900a90b2.gif";